import React from 'react';
import FadeIn from '../components/ui/FadeIn';
import Button from '../components/ui/Button';
import { Link } from 'react-router-dom';

const Home = () => {
  const images = {
    hero: "https://media-manager-c.questera.ai/greta-media/9c5adfa6bba615730f4558013336717062b18ab46d11ed47c31c88c932e61ffbf11018f89f2243f6aef891f7c9f9eda4/images/aW1hZ2UvanBlZw==/29b85b530b54e0e998ba47a289a16b46.JPG",
    studio: "https://media-manager-c.questera.ai/greta-media/9c5adfa6bba615730f4558013336717062b18ab46d11ed47c31c88c932e61ffbf11018f89f2243f6aef891f7c9f9eda4/images/aW1hZ2UvanBlZw==/377b0c2917a996a8909e37a9d836ef43.jpg",
  };

  return (
    <div className="overflow-x-hidden">
      {/* Hero */}
      <section className="relative h-screen flex items-center px-6 md:px-24">
        <div className="absolute inset-0 z-0">
          <img src={images.hero} alt="Hero" className="w-full h-full object-cover" />
          <div className="absolute inset-0 bg-brand-charcoal/40 md:bg-gradient-to-r md:from-brand-charcoal/60 md:to-transparent"></div>
        </div>
        <div className="relative z-10 max-w-4xl pt-20">
          <FadeIn>
            <h1 className="text-[14vw] md:text-[10rem] text-white leading-[0.85] mb-8 font-heading">
              Create.<br />Build.<br /><span className="serif-italic text-brand-orange">Grow.</span>
            </h1>
            <p className="text-xl md:text-2xl text-white/90 max-w-xl mb-12 font-medium">
              A creative studio for brands, creators, and businesses ready to show up clearly and confidently.
            </p>
            <div className="flex flex-wrap gap-5">
              <Button href="https://lbbrandhaus.nuvoro.net/" variant="accent">Book a Session</Button>
              <Button href="https://youtu.be/fCpEPXSLPl8" variant="outline" className="!text-white !border-white hover:!bg-white hover:!text-brand-charcoal">Explore the Studio</Button>
            </div>
          </FadeIn>
        </div>
      </section>

      {/* What We Do */}
      <section className="py-40 bg-brand-ivory">
        <div className="container mx-auto px-6">
          <div className="max-w-3xl mb-32">
            <FadeIn>
              <span className="text-[10px] font-bold tracking-[0.4em] uppercase text-brand-orange mb-6 block">What We Do</span>
              <h2 className="text-5xl md:text-7xl mb-8 font-heading">Services for clarity, creativity, and <span className="serif-italic">growth.</span></h2>
              <p className="text-xl text-brand-teal/80 leading-relaxed">
                LB Brand Haus brings strategy and visuals together so your brand doesn’t just look good… it works.
              </p>
            </FadeIn>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-16">
            {[
              { title: "Brand Strategy", desc: "Clarity in your message, positioning, and direction." },
              { title: "Content Creation", desc: "Visual content designed to connect and convert." },
              { title: "Photography", desc: "Clean, intentional images that reflect your value." }
            ].map((s, i) => (
              <FadeIn key={i} delay={i * 0.1} className="p-10 bg-white shadow-sm rounded-3xl border border-brand-teal/5">
                <h3 className="text-2xl mb-4 font-heading">{s.title}</h3>
                <p className="text-brand-charcoal/70 leading-relaxed">{s.desc}</p>
              </FadeIn>
            ))}
          </div>
        </div>
      </section>

      {/* Studio Rental CTA */}
      <section className="py-40 bg-brand-charcoal text-white">
        <div className="container mx-auto px-6">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-24 items-center">
            <FadeIn direction="right" className="image-zoom-container aspect-[4/5]">
              <img src={images.studio} alt="Studio" className="w-full h-full object-cover" />
            </FadeIn>
            <FadeIn direction="left">
              <h2 className="text-6xl md:text-8xl mb-8 font-heading">Create in a space that <span className="serif-italic text-brand-orange">works.</span></h2>
              <p className="text-xl opacity-80 mb-12 leading-relaxed">
                Our studio is designed for creators, brands, and photographers who need a clean, styled environment to bring ideas to life.
              </p>
              <div className="flex flex-col gap-6">
                <div className="text-4xl font-serif italic text-brand-orange">$70/hour</div>
                <Button href="https://lbbrandhaus.nuvoro.net/business/lbbrandhaus/service/studio-rental" variant="accent">Book the Studio</Button>
              </div>
            </FadeIn>
          </div>
        </div>
      </section>

      {/* Why Us */}
      <section className="py-40 bg-brand-bone text-center">
        <div className="container mx-auto px-6">
          <FadeIn className="max-w-4xl mx-auto">
            <h2 className="text-5xl md:text-7xl mb-12 font-heading">Not just content. Not just strategy.</h2>
            <p className="text-2xl md:text-4xl font-serif italic text-brand-teal leading-relaxed mb-16">
              "A space where everything comes together—so you can show up clearly, consistently, and confidently."
            </p>
            <Button to="/booking" variant="primary" className="px-16">Book Your Session</Button>
          </FadeIn>
        </div>
      </section>
    </div>
  );
};

export default Home;